export default __webpack_public_path__ + "static/media/Dark-commentIcon.5a2558fc.svg";